// for hero areas (no carousel)
const { MediaQuery } = window.Foundation;
import Player from "@vimeo/player";
(() => {
  //units in px
  let iframes = Array.from(document.querySelectorAll(".heroSection iframe"));
  let players = [];
  MediaQuery._init();

  // if window size is small then set thumbnails
  const checkAndSetVideoThumbnails = () => {
    if (window.Foundation.MediaQuery.current == "small") {
      iframes.forEach(async (iframe) => {
        let videoId = null;
        try {
          videoId = iframe.getAttribute("data-src").match(/\d+/gm)[0];
        } catch (err) {
          console.error("No valid video id set");
        }
        if (videoId == null) {
          return;
        }
        if (!iframe.parentElement.hasAttribute("data-hasThumbnail")) {
          try {
            let res = await fetch(
              `https://vimeo.com/api/oembed.json?url=https://vimeo.com/video/${videoId}&width=1280&height=720`
            );
            if (!res.ok) {
              console.error(res.status);
            } else {
              let data = await res.json();
              let imgTag = iframe.parentElement.querySelector("img");
              imgTag.src = data["thumbnail_url"];
            }
          } catch (e) {
            console.error(e);
          }
        }
      });
      window.removeEventListener("load", checkAndSetVideoThumbnails);
      window.removeEventListener("resize", checkAndSetVideoThumbnails);
    }
  };

  const setVideoPlayers = () => {
    if (window.Foundation.MediaQuery.is("medium")) {
      iframes.forEach((iframe) => {
        let player = new Player(iframe);
        players.push(player);
        player.ready().then(function() {
          $(iframe).closest('.heroSection').find('.img__videoThumbnail').addClass("iframeLoaded");
      });
      });
      window.removeEventListener("load", setVideoPlayers);
      window.removeEventListener("resize", setVideoPlayers);
      // fix staging site not autoplaying videos, despite them being muted, for hero areas
      // not really sure why this happens only on stage (not occurring on dev) AND only on DMC's
      // promo video
      players.forEach((player) => player.play());
    }
  };
  const handleVideoButton = function (e) {
    let currIframe =
      e.target.parentElement.parentElement.querySelector("iframe");
    if (currIframe) {
      let idx = iframes.indexOf(currIframe);
      let isActive = e.target.getAttribute("aria-pressed") === "true";
      if (!isActive) {
        players[idx].pause();
      } else {
        players[idx].play();
      }
      e.target.setAttribute("aria-pressed", `${!isActive}`);
    }
  };
  window.handleVideoButton = handleVideoButton;
  window.addEventListener("load", checkAndSetVideoThumbnails);
  window.addEventListener("resize", checkAndSetVideoThumbnails);
  window.addEventListener('load', setVideoPlayers);
  window.addEventListener('resize', setVideoPlayers);
})();

document.addEventListener("DOMContentLoaded", function () {
  // indicate JS is loaded to help manage FOUC (apply to all .heroSection types)
  const heroSections = document.querySelectorAll(".heroSection");
  heroSections.forEach(function (section) {
    section.classList.add("f__loaded");
  });
});
